<hpf-video-form
        *ngIf="video"
        [video]="video"
        (create)="onCreate($event)"
    ></hpf-video-form>
<div *ngIf="!video" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>